import { Component } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'ps-feasibility-details',
  templateUrl: './feasibility-details.component.html',
  styleUrls: ['./feasibility-details.component.css'],
})
export class FeasibilityDetailsComponent {
  public token: string = '';
  public payload: string = '';
  public response: any = {};
  public loading: boolean = false;
  public error: string = '';
  use_case = '';
  total_feasibility: any;
  group_counts: any;
  // active tab for the UI
  public activeTab: string = 'overview';
  deviation: any;
  supplier_factor: any;
  supplierDetails: Record<string, any> = {};
  supplierExpanded: Record<string, boolean> = {};
  group_counts_factor: any;
  quota_list: any;
  redistributionAdditions: any;

  constructor(private _http: HttpClient, private _auth: AuthService) {}
  private _feasibilityUrl = environment.pureSpectrum.feasibilityUrl;

  async callFeasibility() {
    this.loading = true;
    this.error = '';
    let headers = new HttpHeaders();
    const token = this._auth.token || '';
    headers = headers.set('access-token', token);
    try {
      this._http
        .post(
          `${this._feasibilityUrl}/feasibility/v3/report?summary=2&UI=1`,
          JSON.parse(this.payload),
          { headers }
        )
        .subscribe(
          (data) => {
            this.loading = false;
            this.response = data;

            this.use_case = this.response.report.use_case;
            this.total_feasibility = this.response.total_feasibility;
            console.log(this.response.report.groupQuotasCounts);
            this.group_counts = this.convertObjectList(
              this.getData(this.response.report.data, 'groupQuotasCounts')
            );
            this.deviation = this.getData(
              this.response.report.data,
              'Deviation'
            );
            this.supplier_factor = this.getData(
              this.response.report.data,
              'suppliersFactor'
            );
            this.group_counts_factor = this.convertObjectList(
              this.getData(this.response.report.data, 'groupQuotaFactor')
            );
            console.log(this.group_counts_factor);
            this.quota_list = this.getData(
              this.response.report.data,
              'quotaFactor'
            );
            this.redistributionAdditions = this.getData(
              this.response.report.data,
              'redistributionAdditions'
            );
          },
          (error) => {
            this.error = error;
            this.loading = false;
          }
        );
    } catch (error) {
      this.error = 'Error on Calling Service';
      this.loading = false;
    }
  }

  isSupplierGotExtraValue(supplierId: any, quotaId: any): boolean {
    if (
      this.redistributionAdditions.find(
        (distribution: any) =>
          distribution.supplierId == supplierId &&
          distribution.quotaId == quotaId
      )
    ) {
      return true;
    }
    return false;
  }

  getSupplierId(s: any) {
    return s?.id ?? s?.supplier_id ?? s?.s_id ?? null;
  }

  isExpanded(id: any) {
    if (id === null || id === undefined) {
      return false;
    }
    return !!this.supplierExpanded[id];
  }

  getGroupFactor(key: string) {
    return this.group_counts_factor.find(
      (quotagroup: any) => quotagroup.key === key
    ).factor;
  }

  toggleSupplierDetails(supplier: any) {
    const id = this.getSupplierId(supplier);
    if (!id) {
      return;
    }

    // collapse if already expanded
    if (this.supplierExpanded[id]) {
      this.supplierExpanded[id] = false;
      return;
    }

    // try to find related metadata in the response
    const feasMeta = this.getData(
      this.response.report.data,
      'feasbilityMetaData'
    );
    const factorEntry = (this.supplier_factor || []).find(
      (e: any) => e.id === id || e.supplier_id === id
    );
    const countEntry = (this.response.suppliers || []).find(
      (e: any) => e.supplier_id === id || e.id === id
    );
    const metaSupplier = feasMeta?.suppliers?.find((e: any) => e.id === id);
    const suppFeas = feasMeta?.suppFeas?.find((e: any) => e.s_id === id);

    this.supplierDetails[id] = {
      factorEntry,
      countEntry,
      metaSupplier,
      suppFeas,
    };
    this.supplierExpanded[id] = true;
  }

  setTab(tab: string) {
    this.activeTab = tab;
  }

  getData(data: Record<string, any>[], dataName: string) {
    for (let index = 0; index < data.length; index++) {
      const objecto = data[index];
      if (objecto.hasOwnProperty(dataName)) {
        return objecto[dataName];
      }
    }
    return {};
  }

  convertObjectList(data: Object) {
    const result = [];
    for (const [key, value] of Object.entries(data)) {
      result.push({
        key,
        ...value,
      });
    }
    return result;
  }
}
